// extracted by mini-css-extract-plugin
export default {"header":"order-action-card_header__MCTPA","title":"order-action-card_title__0xQks","body":"order-action-card_body__18+cp","footer":"order-action-card_footer__73gII"};